export const MAX_ADDRESS_AGE = 3_600_000;
export const MAX_PEER_AGE = 21_600_000;
//# sourceMappingURL=constants.js.map